import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { IAccountDataResolveData } from './account-data.data';
import { AccountDataStore } from './account-data.store';
import { map } from 'rxjs/operators';

@Injectable()
export class AccountDataResolve implements Resolve<IAccountDataResolveData> {
  static RESOLVE = {
    // key is the same as the RESOLVE_KEY in account-data.data.ts
    accountData: AccountDataResolve,
  };

  constructor(private _accountDataStore: AccountDataStore) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IAccountDataResolveData> {
    return forkJoin(
      this._accountDataStore.getAccount(),
      this._accountDataStore.getUser(),
      this._accountDataStore.isOwnerUser()
    ).pipe(
      map(([account, user, isOwner]) => ({
        account,
        user,
        isOwner,
      }))
    );
  }
}
